import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import { Link } from 'react-router'

import styles from './empty_edit_part.less'

import EditPart from 'components/edit_part'

class StandardEditPart extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    subText: PropTypes.string,
    buttonTitle: PropTypes.string,
    targetLocation: PropTypes.string,
    onClick: PropTypes.func,
    editName: PropTypes.string,
  }

  handleClick = e => {
    if (this.props.onClick) {
      e.preventDefault()
      this.props.onClick()
    }
  }

  render() {
    return (
      <EditPart editButtonDisplay="hide" labelName={this.props.title}>
        <div styleName="title">{this.props.title}</div>
        <div styleName="description">{this.props.description}</div>
        {this.props.subText && (
          <div styleName="subtext">{this.props.subText}</div>
        )}
        <Link
          onClick={this.handleClick}
          to={this.props.targetLocation}
          className="vx_btn vx_btn-secondary vx_btn-medium"
          styleName="add-button"
          data-nemo={`edit-${this.props.editName}`}
        >
          {this.props.buttonTitle}
        </Link>
      </EditPart>
    )
  }
}

export default cssModules(StandardEditPart, styles)
